import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import {Share2, UserPen} from 'lucide-react';
import {Button, ResponsiveSheet, useModalControls} from '@chekinapp/ui';
import {KIOSKO_BUTTON_CLASSES} from 'utils/kioskoClasses';

type Props = {
  onCompleteGuestData?: () => void;
  onShareRegistrationLink?: () => void;
  canShareRegistrationLink?: boolean;
};
function IncompleteGuestsModal({
  onCompleteGuestData,
  onShareRegistrationLink,
  canShareRegistrationLink,
}: Props) {
  const {t} = useTranslation();
  const {state} = useLocation();
  const {openModal, closeModal, isOpen} = useModalControls();

  const handleCompleteGuestData = () => {
    closeModal();
    onCompleteGuestData?.();
  };

  const handleShareRegistrationLink = () => {
    closeModal();
    onShareRegistrationLink?.();
  };

  useEffect(() => {
    if (state?.hasIncompleteGuests) {
      openModal();
    }
  }, [openModal, state]);

  return (
    <ResponsiveSheet
      open={isOpen}
      onClose={closeModal}
      title={t('incomplete_guest_data')}
      description={t('incomplete_guest_data_text')}
      className="incomplete-guests-modal"
      dialogClassName="max-w-[400px] sm:max-w-[400px]"
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
      closeOnOverlayClick={false}
      closeOnEscape
    >
      <div className="mt-5 flex flex-col gap-3">
        <Button onClick={handleCompleteGuestData} className={KIOSKO_BUTTON_CLASSES}>
          <UserPen size={16} />
          {t('complete_guest_data')}
        </Button>
        {canShareRegistrationLink && (
          <Button
            variant="outline"
            onClick={handleShareRegistrationLink}
            className={KIOSKO_BUTTON_CLASSES}
          >
            <Share2 size={16} />
            {t('share_registration_link')}
          </Button>
        )}
      </div>
    </ResponsiveSheet>
  );
}

export {IncompleteGuestsModal};
